import Joi from "joi";
import errorsResolver from "../schemeUtils";

const amountMax = 99999999.99

export const nonCashValidate = Joi.object({
    cash: Joi.number()
        .min(0)
        .max(amountMax)
        .custom((value, helpers) => {
            const precision = 2;
            const roundedValue = Number(value.toFixed(precision));
            if (roundedValue !== value) {
                return helpers.error('number.precision', { limit: precision, value });
            }
            if (value.toString().endsWith('.')) {
                return helpers.error('number.format', { value });
            }
            return value;
        })
        .error(errorsResolver({
            precision: 'Значение не может быть больше 2 знаков после запятой',
            numberBase: 'Наличные должно быть корректным числом',
            numberUnsafe: 'Наличные должно быть корректным числом',
            numberMin: `Наличные должно быть больше 0`,
            numberMax: `Наличные должно быть меньше ${amountMax}`,
            required: 'Наличные обязательное поле',
            number: 'Наличные должно быть числом',
        })),
    nonCash: Joi.number()
        .min(0)
        .max(99999999.99)
        .custom((value, helpers) => {
            const precision = 2;
            const roundedValue = Number(value.toFixed(precision));
            if (roundedValue !== value) {
                return helpers.error('number.precision', { limit: precision, value });
            }
            if (value.toString().endsWith('.')) {
                return helpers.error('number.format', { value });
            }
            return value;
        })
        .error(errorsResolver({
            numberBase: `Безналичные должно быть корректным числом`,
            precision: 'Значение не может быть больше 2 знаков после запятой',
            numberUnsafe: `Безналичные должно быть корректным числом`,
            numberMin: `Безналичные должно быть больше 0`,
            numberMax: `Безналичные должно быть меньше ${amountMax}`,
            required: `Безналичные обязательное поле`,
            number: `Безналичные должно быть числом`
        })),
    nonCashAccount: Joi.number()
        .min(0)
        .max(99999999.99)
        .custom((value, helpers) => {
            const precision = 2;
            const roundedValue = Number(value.toFixed(precision));
            if (roundedValue !== value) {
                return helpers.error('number.precision', { limit: precision, value });
            }
            if (value.toString().endsWith('.')) {
                return helpers.error('number.format', { value });
            }
            return value;
        })
        .error(errorsResolver({
            numberBase: `Безналичные должно быть корректным числом`,
            precision: 'Значение не может быть больше 2 знаков после запятой',
            numberUnsafe: `Безналичные должно быть корректным числом`,
            numberMin: `Безналичные должно быть больше 0`,
            numberMax: `Безналичные должно быть меньше ${amountMax}`,
            required: `Безналичные обязательное поле`,
            number: `Безналичные должно быть числом`
        })),
    bankTransaction: Joi.number()
        .min(0)
        .max(99999999.99)
        .custom((value, helpers) => {
            const precision = 2;
            const roundedValue = Number(value.toFixed(precision));
            if (roundedValue !== value) {
                return helpers.error('number.precision', { limit: precision, value });
            }
            if (value.toString().endsWith('.')) {
                return helpers.error('number.format', { value });
            }
            return value;
        })
        .error(errorsResolver({
            numberBase: `Ерип должно быть корректным числом`,
            precision: 'Значение не может быть больше 2 знаков после запятой',
            numberUnsafe: `Ерип должно быть корректным числом`,
            numberMin: `Ерип должно быть больше 0`,
            numberMax: `Ерип должно быть меньше ${amountMax}`,
            required: `Ерип обязательное поле`,
            number: `Ерип должно быть числом`
        })),
})